import {CodeLabelEGalim} from 'api-types/ffconnect';

export interface LabelEGalim {
  code: CodeLabelEGalim;
  libelle: string;
}

/** Labels officiels (toujours affichés) */
export const LABELS_OFFICIELS: LabelEGalim[] = [
  {code: 'BIO', libelle: 'Bio'},
  {code: 'LR', libelle: 'Label Rouge'},
  {code: 'AOP', libelle: 'AOP AOC'},
  {code: 'IGP', libelle: 'IGP'},
  {code: 'STG', libelle: 'STG'},
  {code: 'FERM', libelle: 'Produits Fermier'},
  {code: 'COMEQ', libelle: 'Commerce Équitable'},
  {code: 'HVE3', libelle: 'Haute Valeur Environnementale'},
  {code: 'HVE2', libelle: 'Certification environnementale niv.2'},
];

/** Labels non-officiels (affichés uniquement si sélectionnés par le client) */
export const LABELS_ELIGIBLES: LabelEGalim[] = [
  {code: 'BBC', libelle: 'Bleu Blanc Coeur'},
  {code: 'PDUR', libelle: 'Pêche Durable'},
  {code: 'EE', libelle: 'Externalités environnementales'},
  {code: 'EBE', libelle: 'Élevages Bien-Être'},
];
